var GPPLoadViewController = (function () {
    function GPPLoadViewController(env, $filter, $stateParams, $state, socket, $scope, admin) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.profileLoaded = false;
        this.serverError = undefined;
        this.profile = {};
        this.socket.forward('config.gppload_profile', this.$scope);
        this.$scope.$on('socket:config.gppload_profile', function (event, payload) {
            if (angular.isDefined(payload.error)) {
                _this.serverError = payload.error;
            }
            else {
                _this.profile = payload.data;
                _this.profileLoaded = true;
            }
        });
    }
    GPPLoadViewController.prototype.toggle = function (ting) {
        if (angular.isDefined(ting.view)) {
            ting.view = !ting.view;
        }
        else {
            ting.view = true;
        }
    };
    GPPLoadViewController.prototype.$onInit = function () {
        this.admin.getGPPLoadProfile();
    };
    GPPLoadViewController.$inject = ['env', '$filter', '$stateParams', '$state', 'socket', '$scope', 'admin'];
    return GPPLoadViewController;
}());
var GPPLoadViewComponent = (function () {
    function GPPLoadViewComponent() {
        this.templateUrl = 'gppload-view.html';
        this.controllerAs = 'vm';
        this.controller = GPPLoadViewController;
    }
    return GPPLoadViewComponent;
}());
angular
    .module('application')
    .component('viewGpploadSection', new GPPLoadViewComponent());

//# sourceMappingURL=gppload.view.component.js.map
